import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: theme.spacing(8, 3),
    minHeight: 400,
  },
  iconWrapper: {
    width: 72,
    height: 72,
    border: `1.5px solid ${theme.palette.primary.main}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(4),
  },
  icon: {
    fontSize: 36,
    color: theme.palette.primary.main,
  },
  heading: {
    fontSize: "1.625rem",
    fontWeight: 700,
    color: theme.palette.text.primary,
    letterSpacing: "-0.02em",
    marginBottom: theme.spacing(2),
    lineHeight: 1.2,
  },
  body: {
    fontSize: "0.9375rem",
    color: theme.palette.text.secondary,
    lineHeight: 1.7,
    maxWidth: 480,
    marginBottom: theme.spacing(1.5),
  },
  highlight: {
    fontSize: "0.8125rem",
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    maxWidth: 440,
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: "rgba(0,0,0,0.015)",
    marginTop: theme.spacing(2),
  },
  referenceId: {
    fontSize: "0.75rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginTop: theme.spacing(3),
  },
}));

const ThankYouMessage = ({ referenceId, contactEmail }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.iconWrapper}>
        <CheckCircleOutlineIcon className={classes.icon} />
      </Box>

      <Typography className={classes.heading}>
        Request Submitted Successfully
      </Typography>

      <Typography className={classes.body}>
        Thank you for submitting your Mediation Request. We have received your
        application and our team will review the details provided.
      </Typography>

      <Typography className={classes.body}>
        A confirmation has been sent to the email address provided. You can
        expect to hear from our Mediation Centre within <strong>2–3 working days</strong>.
      </Typography>

      {/* <Box className={classes.highlight}>
        <Typography style={{ fontSize: "0.8125rem", lineHeight: 1.65 }}>
          If you have any urgent queries or wish to follow up on your request,
          please write to us at{" "}
          <strong>{contactEmail}</strong> quoting your reference number.
        </Typography>
      </Box>

      {referenceId && (
        <Typography className={classes.referenceId}>
          Reference: {referenceId}
        </Typography>
      )} */}
    </Box>
  );
};

export default ThankYouMessage;
